/* eslint-disable @next/next/no-img-element */
import parse from "react-html-parser"
import { observer } from "mobx-react"
import { useStore } from "@features/common"
import { BreakPoints } from "styles/styles"

import DevilWithLock from "./devil-with-lock.png"
import Police from "./police.png"
import PoliceDesktop from "./police-desktop.png"
import Batman from "./batman.png"
import PrivacyAndSafetyBg from "./privacy-and-safety-bg.svg"
import PrivacyAndSafetyBgMobile from "./privacy-and-safety-bg-mobile.svg"
import Star from "./star.png"

export const PrivacyAndSafety = () => {
  const {
    TeamPageModel: { getTemplate },
    ResponsiveModel: { width },
  } = useStore()
  const isMobile = width > 0 && width < BreakPoints.tablet

  const headingDesktop = parse(
    getTemplate("about.privacy.heading.desktop", false) ||
      "Privacy & Safety:<br/>Our top Priority",
  )

  const headingMobileTop = parse(
    getTemplate("about.privacy.heading.mobileTop", false) || "Privacy & Safety",
  )
  const headingMobileBottom = parse(
    getTemplate("about.privacy.heading.mobileBottom", false) ||
      "Our top Priority",
  )
  const introText =
    getTemplate("about.privacy.heading.description", false) ||
    "You can only have fun if you’re comfortable. We know that. So you’re in charge of your rules."
  const controlTitle = parse(
    getTemplate("about.privacy.control.title", isMobile) ||
      "You’re in control<br/> of your boundaries",
  )
  const controlText =
    getTemplate("about.privacy.control.description", false) ||
    "Our team backs you up with clear community guidelines and active moderation to keep the vibe right for everyone."
  const anonymousTitle = parse(
    getTemplate("about.privacy.anonymous.title", isMobile) ||
      "You can stay anonymous<br/>until you’re ready",
  )

  const anonymousText =
    getTemplate("about.privacy.anonymous.description", false) ||
    "Chats and photos disappear if you want them to. Explicit pics stay blurred until you decide to see them. Not sure if someone is real? Request a live photo. And of course, absolutely no screenshots."

  return (
    <section className="relative w-full mt-[60px] mb-0 laptop:mb-[120px]">
      <PrivacyAndSafetyBg
        viewBox="0 0 1440 829"
        className="tablet-lg:block hidden absolute top-[-100px] left-0 w-full -z-1 pointer-events-none select-none"
      />
      <PrivacyAndSafetyBgMobile
        viewBox="0 0 375 400"
        className="tablet-lg:hidden block absolute top-0 left-0 w-full -z-1 pointer-events-none select-none"
      />
      <div className="max-w-screen-desktop-l px-[30px] mx-auto">
        <div className="flex justify-center gap-[120px] mb-[50px] laptop:mb-0">
          <div>
            <div className="block laptop:hidden font-pure rotate-[-5.47deg] leading-[48px] tablet:leading-[64px] text-[36px] tablet:text-[64px] mt-[60px] mb-[10px]">
              {headingMobileTop}
            </div>
            <img
              src={DevilWithLock.src}
              alt="Devil with Lock"
              className="max-w-none ml-[25px] laptop:ml-0 mt-0 laptop:mt-[70px] relative h-[266px] laptop:h-[470px]"
            />
            <div className="block laptop:hidden laptop:ml-0 font-pure rotate-[-5.47deg] leading-[48px] tablet:leading-[64px] text-[36px] tablet:text-[64px] text-right mb-[70px]">
              {headingMobileBottom}
            </div>
          </div>
          <div className="hidden laptop:block mb-[165px] max-w-[500px]">
            <div className="font-pure rotate-[3deg] leading-[48px] tablet:leading-[64px] text-[36px] tablet:text-[64px] mb-[70px]">
              {headingDesktop}
            </div>
            <div className="ml-[30px] font-sans text-[16px] tablet-lg:text-[24px] leading-[20px] tablet-lg:leading-[32px] rotate-[-3deg] w-[65%]">
              {introText}
            </div>
          </div>
        </div>

        <div className="flex flex-col-reverse desktop:flex-row justify-center items-center desktop:items-end gap-0 desktop:gap-[180px]">
          <div className="max-w-[430px]">
            <div className="relative w-fit top-0 desktop:top-[100px]">
              <img
                src={PoliceDesktop.src}
                alt="Police"
                className="hidden laptop:block h-[322px] relative top-0 right-[-100px]"
              />
              <img
                src={Police.src}
                alt="Police"
                className="block laptop:hidden h-[250px] relative top-0 right-0"
              />

              <div className="relative left-0 laptop:left-[-50px] bottom-[50px] laptop:bottom-[105px]">
                <div className="rotate-[-4deg] ml-0 laptop:ml-[-7px] mr-[20px] laptop:mr-0 mb-[30px] laptop:mb-[40px] font-sans-bold text-[14px] laptop:text-[24px] leading-[18px] laptop:leading-[40px]">
                  {controlTitle}
                </div>
                <div className="rotate-[-2deg] w-[90%] laptop:w-[400px] font-sans text-[16px] leading-[20px] laptop:text-[20px] laptop:leading-[32px]">
                  {controlText}
                </div>
              </div>
            </div>
          </div>

          <div className="max-w-[430px]">
            <div className="relative w-fit">
              <img
                src={Star.src}
                alt="Star"
                className="absolute tablet-lg:hidden top-[-40px] right-[25%] w-[45px]"
              />
              <img
                src={Batman.src}
                alt="Batman"
                className="block h-[209px] laptop:h-[284px]"
              />

              <div className="relative bottom-[50px] laptop:bottom-[95px] left-[10px]">
                <div className="rotate-[2deg] mb-[30px] laptop:mb-[40px] mr-[20px] laptop:mr-0 font-sans-bold text-[14px] laptop:text-[24px] leading-[18px] laptop:leading-[40px]">
                  {anonymousTitle}
                </div>
                <div className="rotate-[-2deg] w-[90%] laptop:w-[420px] font-sans text-[16px] leading-[20px] laptop:text-[20px] laptop:leading-[32px]">
                  {anonymousText}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

const PrivacyAndSafetyComponent = observer(PrivacyAndSafety)

export { PrivacyAndSafetyComponent }
